
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-moving-and-storage",
      function () {
        return require("private-next-pages/office-moving-and-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-moving-and-storage"])
      });
    }
  